var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "info-icon test12",
    width: "18px",
    height: "19px",
    viewBox: "0 0 18 19",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Info") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.03, 0.5608)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.22,8.71915145 C17.11,7.82915145 16.47,6.10915145 16.34,5.21915145 C16.2,4.24915145 14.9,2.89915145 14.29,2.10915145 C13.36,0.889151445 12.32,0.529151445 9.98,0.119151445 C8.88,-0.080848555 7.73,-0.040848555 6.68,0.329151445 C5.53,0.729151445 4.05,1.41915145 2.25,2.38915145 C0.75,3.44915145 0,6.23915145 0,10.7691514 L0,11.5591514 C2.13,15.5591514 4.35,17.7091514 6.64,17.5591514 C7.47,17.4991514 9.44,17.2091514 10.56,17.0491514 C11.09,16.9691514 11.63,16.8291514 12.13,16.6191514 C16.62,14.7491514 17.72,12.7791514 17.22,8.71915145",
    className: "path",
    fill: "#9CCB55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.06,5.58915145 C9.75,5.58915145 10.17,5.04915145 10.24,4.36915145 C10.28,4.01915145 10.1,3.64915145 9.87,3.48915145 C9.67,3.35915145 9.43,3.17915145 9.06,3.18915145 C8.37,3.21915145 7.91,3.73915145 7.88,4.25915145 C7.86,4.70915145 7.91,5.05915145 8.07,5.26915145 C8.27,5.53915145 8.71,5.58915145 9.06,5.58915145",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.62,11.6791514 C10.38,11.6891514 10.2,11.6991514 10.04,11.7091514 C10.05,11.5191514 10.09,10.7991514 10.04,10.1391514 C10.03,9.87915145 10.01,8.61915145 10.06,7.38915145 C10.08,7.08915145 10.1,6.74915145 9.97,6.56915145 C9.88,6.41915145 8.02,6.38915145 7.35,6.46915145 C7.23,6.47915145 7.17,6.50915145 7.14,6.66915145 C7.1,6.97915145 7.08,7.53915145 7.25,7.52915145 C7.53,7.50915145 7.83,7.49915145 8.11,7.49915145 C8.13,7.79915145 8.15,8.03915145 8.15,8.23915145 C8.15,8.58915145 8.06,10.4391514 8.09,10.8391514 C8.13,11.1791514 8.11,11.5591514 8.12,11.7791514 C7.88,11.7691514 7.64,11.7591514 7.41,11.7491514 C7.24,11.7391514 7.17,11.7791514 7.14,11.9491514 C7.11,12.2691514 7.12,12.8391514 7.34,12.8191514 C8.12,12.7591514 9.06,12.7991514 9.44,12.7791514 C10.08,12.7591514 10.43,12.6991514 10.98,12.6591514 L11.04,11.8791514 C11.05,11.6691514 11.01,11.6091514 10.62,11.6791514",
    fill: "#FFFFFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInfo);
export default __webpack_public_path__ + "static/media/icon-info.b629556d7b03a669206402dfea61a648.svg";
export { ForwardRef as ReactComponent };